export default __webpack_public_path__ + "static/restaurant-5aa9e10f9ffe90971844adcf3b39c8f9.jpg";